import Tasks from 'APP/Tasks';
import { IDeviceStatusUpdateEvent } from 'APP/model/counter/counterModel.types';
import Entities from 'STORE';

export async function handleDeviceStatusUpdate(data: IDeviceStatusUpdateEvent): Promise<void> {
  const device = Entities.sessionsStore.getSessionByKey(data.deviceId);

  if (!device) {
    await Tasks.userSettings.getSessionsInfo();
  }

  Entities.sessionsStore.setSessionDeviceStatus(data.deviceId, data.status);
}
